import { css } from "lit";

// Layout & dimensions sourced from Figma node 1170:698 (Live Event Pages —
// "Pellet Send 1"). The banner picks up the creator's theme: `primaryColor`
// becomes the banner background, `secondaryColor` the foreground (text and
// progress-bar). When no creator theme is provided, we fall back to the
// shared SDS brand tokens — the Figma red/white in that file are just one
// creator's example palette, not the system fallback.
export const styles = css`
  :host {
    display: block;
  }

  .bar {
    background: var(--sds-color-background-brand-tertiary);
    border-radius: 4px;
    overflow: hidden;
  }
  .bar.thin {
    height: 4px;
  }
  .bar.thin .bar-fill {
    height: 100%;
    background: var(--sds-color-text-brand-on-brand);
    transition: width 200ms ease-out;
  }

  .banner {
    background: var(--donation-banner-bg, var(--sds-color-background-brand-default));
    color: var(--donation-banner-fg, var(--sds-color-text-brand-on-brand));
    padding: 10px 20px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
  .banner .row {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    width: 100%;
    gap: 4px;
  }
  .banner .labels {
    font-size: 11px;
    font-weight: 600;
    line-height: 1.2;
  }
  .banner .amounts {
    font-size: 10px;
    font-weight: 400;
    line-height: 1.2;
  }
  .banner .target-label,
  .banner .target-amount {
    text-align: right;
  }

  .bar.full {
    background: transparent;
    border-radius: 0;
    overflow: visible;
    display: flex;
    width: 100%;
    height: 11px;
    box-sizing: border-box;
  }
  .bar.full .bar-fill {
    background: var(--donation-banner-fg, var(--sds-color-text-brand-on-brand));
    height: 100%;
    border-top-left-radius: 33px;
    border-bottom-left-radius: 33px;
    flex-shrink: 0;
    box-sizing: border-box;
    transition: width 200ms ease-out;
  }
  .bar.full .bar-fill.solo {
    border-radius: 33px;
  }
  .bar.full .bar-empty {
    border: 1px solid var(--donation-banner-fg, var(--sds-color-text-brand-on-brand));
    height: 100%;
    border-top-right-radius: 33px;
    border-bottom-right-radius: 33px;
    flex: 1;
    box-sizing: border-box;
  }
  .bar.full .bar-empty.solo {
    border-radius: 33px;
  }
`;
